import styled from "styled-components";
import BoxBase from "../BoxBase";
import { BoxProps } from "./Box.types";

export const StyledBox = styled(BoxBase)<BoxProps>``;
